module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress",
    attrs: {
      "id": "app"
    }
  }, [_c('demonstration', {
    attrs: {
      "tag": "h2",
      "title": "Progress 进度条",
      "anchor": "progress-jin-du-tiao",
      "description": "用于展示操作进度，告知用户当前状态和预期。",
      "show-content": false
    }
  }), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "线形进度条 — 百分比外显",
      "anchor": "xian-xing-jin-du-tiao-bai-fen-bi-wai-xian",
      "highlight": _vm.sourcecodeA,
      "multiple": true
    }
  }, [_c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "vd-demo__block vd-demo__block-2"
  }, [_c('span', {
    staticClass: "vd-demo__demonstartion"
  }, [_vm._v("默认文字")]), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 0
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 70
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 30,
      "strokeColor": "purple"
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 30,
      "status": "exception"
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 50,
      "status": "info"
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 80,
      "status": "warning"
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 100,
      "status": "success"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-2 vd-custom-text"
  }, [_c('span', {
    staticClass: "vd-demo__demonstartion"
  }, [_vm._v("自定义文字，需要附加样式")]), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 0
    }
  }, [_vm._v("占比 0%")]), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 70
    }
  }, [_vm._v("占比 70%")]), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 30,
      "strokeColor": "purple"
    }
  }, [_vm._v("占比 30%")]), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 30,
      "status": "exception"
    }
  }, [_vm._v("占比 30%")]), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 50,
      "status": "info"
    }
  }, [_vm._v("占比 50%")]), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 80,
      "status": "warning"
    }
  }, [_vm._v("占比 80%")]), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 100,
      "status": "success"
    }
  }, [_vm._v("占比 100%")])], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_c('code', [_vm._v("Progress")]), _vm._v(" 组件设置 "), _c('code', [_vm._v("percentage")]), _vm._v(" 属性即可，表示进度条对应的百分比，必填，必须在 "), _c('code', [_vm._v("0-100")]), _vm._v("。\n    ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "线形进度条 — 百分比内显",
      "anchor": "xian-xing-jin-du-tiao-bai-fen-bi-nei-xian",
      "description": "百分比不占用额外控件，适用于文件上传等场景。",
      "highlight": _vm.sourcecodeB,
      "multiple": true
    }
  }, [_c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "vd-demo__block vd-demo__block-2"
  }, [_c('span', {
    staticClass: "vd-demo__demonstartion"
  }, [_vm._v("默认文字")]), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 0,
      "text-inside": true,
      "stroke-width": 18
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 70,
      "text-inside": true,
      "stroke-width": 18
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 30,
      "text-inside": true,
      "stroke-width": 18,
      "strokeColor": "purple"
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 30,
      "text-inside": true,
      "stroke-width": 18,
      "status": "exception"
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 50,
      "text-inside": true,
      "stroke-width": 18,
      "status": "info"
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 80,
      "text-inside": true,
      "stroke-width": 18,
      "status": "warning"
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 100,
      "text-inside": true,
      "stroke-width": 18,
      "status": "success"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-2"
  }, [_c('span', {
    staticClass: "vd-demo__demonstartion"
  }, [_vm._v("自定义文字")]), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 0,
      "text-inside": true,
      "stroke-width": 18
    }
  }, [_vm._v("占比 0%")]), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 70,
      "text-inside": true,
      "stroke-width": 18
    }
  }, [_vm._v("占比 70%")]), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 30,
      "text-inside": true,
      "stroke-width": 18,
      "strokeColor": "purple"
    }
  }, [_vm._v("占比 30%")]), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 30,
      "text-inside": true,
      "stroke-width": 18,
      "status": "exception"
    }
  }, [_vm._v("占比 30%")]), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 50,
      "text-inside": true,
      "stroke-width": 18,
      "status": "info"
    }
  }, [_vm._v("占比 50%")]), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 80,
      "text-inside": true,
      "stroke-width": 18,
      "status": "warning"
    }
  }, [_vm._v("占比 80%")]), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 100,
      "text-inside": true,
      "stroke-width": 18,
      "status": "success"
    }
  }, [_vm._v("占比 100%")])], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_c('code', [_vm._v("Progress")]), _vm._v(" 组件可通过 "), _c('code', [_vm._v("stroke-width")]), _vm._v(" 属性更改进度条的高度，并可通过 "), _c('code', [_vm._v("text-inside")]), _vm._v(" 属性来将进度条描述置于进度条内部。\n    ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "线形进度条 — 渐变条纹",
      "anchor": "xian-xing-jin-du-tiao-bai-fen-bi-wai-xian",
      "highlight": _vm.sourcecodeD
    }
  }, [_c('template', {
    slot: "source"
  }, [_c('vm-button', {
    staticClass: "btn-striped",
    attrs: {
      "type": "info"
    },
    on: {
      "click": function($event) {
        _vm.striped = !_vm.striped
      }
    }
  }, [_vm._v("切换条纹")]), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 0,
      "text-inside": true,
      "stroke-width": 18,
      "striped": _vm.striped
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 70,
      "text-inside": true,
      "stroke-width": 18,
      "striped": _vm.striped
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 30,
      "text-inside": true,
      "stroke-width": 18,
      "strokeColor": "purple",
      "striped": _vm.striped
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 30,
      "text-inside": true,
      "stroke-width": 18,
      "status": "exception",
      "striped": _vm.striped
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 50,
      "text-inside": true,
      "stroke-width": 18,
      "status": "info",
      "striped": _vm.striped
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 80,
      "text-inside": true,
      "stroke-width": 18,
      "status": "warning",
      "striped": _vm.striped
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "percentage": 100,
      "text-inside": true,
      "stroke-width": 18,
      "status": "success",
      "striped": _vm.striped
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_c('code', [_vm._v("Progress")]), _vm._v(" 组件设置 "), _c('code', [_vm._v("striped")]), _vm._v(" 属性即可，表示进度条是否添加条纹渐变动画，还可以通过 `linear-class-name` 定义自己的进度动画。\n    ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "环形进度条",
      "anchor": "huan-xing-jin-du-tiao",
      "multiple": true,
      "highlight": _vm.sourcecodeC
    }
  }, [_c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "vd-demo__block vd-demo__block-2"
  }, [_c('vm-progress', {
    attrs: {
      "type": "circle",
      "percentage": 0
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "type": "circle",
      "percentage": 25
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "type": "circle",
      "percentage": 30,
      "strokeColor": "purple"
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "type": "circle",
      "percentage": 30,
      "status": "exception"
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "type": "circle",
      "percentage": 50,
      "status": "info"
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "type": "circle",
      "percentage": 80,
      "status": "warning"
    }
  }), _vm._v(" "), _c('vm-progress', {
    attrs: {
      "type": "circle",
      "percentage": 100,
      "status": "success"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-2"
  }, [_c('vm-progress', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "type": "circle",
      "percentage": _vm.percentage
    }
  }, [_vm._v("占比" + _vm._s(_vm.percentage) + "%\n        ")]), _vm._v(" "), _c('vm-progress', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "type": "circle",
      "percentage": _vm.percentage
    }
  }), _vm._v(" "), _c('vm-progress', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "type": "circle",
      "percentage": _vm.percentage,
      "reverse": ""
    }
  }), _vm._v(" "), _c('vm-button-group', [_c('vm-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.increase
    }
  }, [_vm._v("增加")]), _vm._v(" "), _c('vm-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.decrease
    }
  }, [_vm._v("减少")])], 1)], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_c('code', [_vm._v("Progress")]), _vm._v(" 组件可通过 "), _c('code', [_vm._v("type")]), _vm._v(" 属性来指定使用环形进度条，在环形进度条中，还可以通过 "), _c('code', [_vm._v("width")]), _vm._v(" 属性来设置其大小。通过 "), _c('code', [_vm._v("reverse")]), _vm._v("\n      设置进度方向（逆时针，顺时针），还可以定义显示内容。\n    ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "Attributes",
      "anchor": "attributes",
      "show-content": false
    }
  }, [_c('template', {
    slot: "table"
  }, [_c('table', {
    staticClass: "vd-demo__table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("可选值")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("striped "), _c('i', {
    staticClass: "vd-demo__new"
  }, [_vm._v("（新增）")])]), _vm._v(" "), _c('td', [_vm._v("是否为进度添加条纹渐变动画")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("linear-class-name "), _c('i', {
    staticClass: "vd-demo__new"
  }, [_vm._v("（新增）")])]), _vm._v(" "), _c('td', [_vm._v("进度渐变类名")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("percentage")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("百分比（必填）")])]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("0-100")]), _vm._v(" "), _c('td', [_vm._v("0")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', [_vm._v("进度条类型")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("line/circle")]), _vm._v(" "), _c('td', [_vm._v("line")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("stroke-width")]), _vm._v(" "), _c('td', [_vm._v("进度条的宽度，单位 px")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("6")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("stroke-color "), _c('i', {
    staticClass: "vd-demo__new"
  }, [_vm._v("（新增）")])]), _vm._v(" "), _c('td', [_vm._v("进度条的颜色")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("track-color "), _c('i', {
    staticClass: "vd-demo__new"
  }, [_vm._v("（新增）")])]), _vm._v(" "), _c('td', [_vm._v("进度条的背景颜色")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("stroke-linecap "), _c('i', {
    staticClass: "vd-demo__new"
  }, [_vm._v("（新增）")])]), _vm._v(" "), _c('td', [_vm._v("进度条顶端的形状（只在 type=circle 时可用）")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("square(方)/round(圆)")]), _vm._v(" "), _c('td', [_vm._v("round")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("text-inside")]), _vm._v(" "), _c('td', [_vm._v("进度条显示文字内置在进度条内（只在 type=line 时可用）")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("status")]), _vm._v(" "), _c('td', [_vm._v("进度条当前状态")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("success/exception/warning/info")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("width")]), _vm._v(" "), _c('td', [_vm._v("环形进度条画布宽度（只在 type=circle 时可用）")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("126")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("show-text")]), _vm._v(" "), _c('td', [_vm._v("是否显示进度条文字内容")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("true")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("reverse "), _c('i', {
    staticClass: "vd-demo__new"
  }, [_vm._v("（新增）")])]), _vm._v(" "), _c('td', [_vm._v("是否是逆时针旋转，（只在type=\"circle\"时可用）")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])])])])])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "Slots",
      "anchor": "slots",
      "show-content": false
    }
  }, [_c('template', {
    slot: "table"
  }, [_c('table', {
    staticClass: "vd-demo__table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("默认")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("default")]), _vm._v(" "), _c('td', [_vm._v("自定义描述文字")]), _vm._v(" "), _c('td', [_vm._v("percentage%")])])])])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8507b446","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/src/App.vue
// module id = 15
// module chunks = 0